export enum LocalstorageKeys {
  DevSettings = 'dev-settings',
}
